import { animate, style, transition, trigger } from '@angular/animations';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { ProjetoList } from '../../models/projeto-list.model';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { NavigationService } from '../../services/navigation.service';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StorageService } from 'src/app/shared/services/storage.service';
import { PermissionAclService } from 'src/app/shared/services/permission-acl.service';

@Component({
  selector: 'app-pesquisa-geral',
  templateUrl: './pesquisa-geral.component.html',
  styleUrls: ['./pesquisa-geral.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ],
})

export class PesquisaGeralComponent extends BaseListComponent<any> implements OnInit {
  form: FormGroup;
  orgaoList: Orgao[];
  errorResolver: any;
  listFilters: any;
  projetoList: ProjetoList[];
  projetoPesquisa: ProjetoList[];
  programaList: any[];
  agregadorList: any[];
  eixoList: any[];
  statusList: any[];
  objEstrategicoList: any[];
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];
  advancedSearchActive: boolean;
  labelAdvancedSearch: string = "Mais Filtros";
  filterObjective: number;
  filterActive: boolean = false;
  filter_pesquisa: string = '';
  pagination = { itemsPerPage: 15, currentPage: 1, totalItems: 0, maxSize: 5 };
  modalPrintRef?: BsModalRef;
  report_type: number = 1;
  reportList = [
    { id: 1, label: 'Visão Geral dos Projetos (lista)' },
    { id: 2, label: 'Relatório Sintético' },
    { id: 3, label: 'Relatório Completo' },
    { id: 4, label: 'Relatório Pontos Críticos' },
  ];

  report_2_param_2 = 0;
  analiseList = [
    { id: 0, label: 'Nenhuma' },
    { id: 1, label: 'Última' },
    { id: 2, label: 'Todas' },
  ];

  report_2_param_1 = [];
  tipoAnaliseList = [
    { num_codigo_pk: 1, str_nome: 'Análise do Gerente' },
    { num_codigo_pk: 2, str_nome: 'Análise Monitoramento' },
  ];

  report_3_param_1 = [];
  infoList = [
    { num_codigo_pk: 1, str_nome: 'Cadastro' },
  ];
  canCreate:boolean = false;

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;
  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public pesquisaGeralService: PesquisaGeralService,
    public irfeProjetoService: IrfeProjetoService,
    public ircpProjetoService: IrcpProjetoService,
    private modalService: BsModalService,
    private storageService: StorageService,
    private navigation: NavigationService,
    private permissionAcl: PermissionAclService
  ) {
    super();
  }

  ngOnInit() {
    this.errorResolver = this.activatedRoute.snapshot.data["listOrgao"];
    this.hasCreatePermission();
    if (this.errorResolver?.error) {
      console.error(this.errorResolver?.message)
      this.msgError('Erro interno na inicialização.');
      this.loaded();
      return;
    }

    if (this.storageService.showWelcome()) {
      this.welcome();
    }
    
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.filterObjective = this.activatedRoute.snapshot.queryParams['filter_objective'];
    this.initForm();
    if (this.filterObjective) {
      this.advancedSearch()
    }
    this.search();
  }

  initForm() {
    this.form = new FormGroup({
      filter_agency: new FormControl(null),
      filter_agency_pg_type1: new FormControl(null),
      filter_agency_pg_type2: new FormControl(null),
      filter_pg_type1: new FormControl(null),
      filter_pg_type2: new FormControl(null),
      filter_axis: new FormControl(null),
      filter_op_status_id: new FormControl(null),
      filter_objective: new FormControl(this.filterObjective ? Number(this.filterObjective) : null),
      filter_with_warn: new FormControl(null),
      filter_actived: new FormControl("1"),
      filter_irfe_enabled_id: new FormControl(null),
      filter_level_priority: new FormControl(null),
      filter_ircp_enabled_id: new FormControl(null),
      filter_tags:new FormArray(
        [new FormGroup({
          id: new FormControl(144),
          table: new FormControl('pf_program'),
          status: new FormControl(null),
        }),
        new FormGroup({
          id: new FormControl(172),
          table: new FormControl('pf_program'),
          status: new FormControl(null),
        }),
      ])
    })
    let filterValue = this.storageService.getFilterValue('filterProjectValue');
    if(filterValue){
      this.filterActive = true;
      this.form.patchValue(filterValue);
    }
  }

  cleanSearch() {
    this.storageService.removeFilterValue('filterProjectValue');
    this.form.reset();
  }

  closeFilter() {
    if (this.filterActive) {
      this.filterActive = false;
      if (this.advancedSearchActive) {
        this.labelAdvancedSearch = "Mais Filtros";
        this.advancedSearchActive = false;
      }
    }
  }

  advancedSearch() {
    if (!this.listFilters) {
      this.loading();
      this.pesquisaGeralService.listFilters().subscribe({
        next: (res) => {
          this.listFilters = res;
          this.programaList = this.listFilters.programa;
          this.statusList = this.listFilters.status;
          this.agregadorList = this.listFilters.agregador;
          this.eixoList = this.listFilters.eixo;
          this.objEstrategicoList = this.listFilters.objetivo;
          this.labelAdvancedSearch = this.advancedSearchActive ? "Mais Filtros" : "Menos Filtros";
          this.advancedSearchActive = !this.advancedSearchActive;
          this.loaded();
        },
      })
    } else {
      if (this.advancedSearchActive) {
        this.cleanSearch();
        this.labelAdvancedSearch = "Mais Filtros";
      } else {
        this.labelAdvancedSearch = "Menos Filtros";
      }
      this.advancedSearchActive = !this.advancedSearchActive;
    }
  }

  getDataCreate(filterSave = false) {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    if (filterSave && !Object.values(data).every(value => value === null)) {
      this.storageService.setFilterValue('filterProjectValue', data);
    }
    return data;
  }

  search(filterSave = false) {
    this.filter_pesquisa = '';
    this.loading();
    this.addSub(
      this.pesquisaGeralService.getListSearchProjetos(this.getDataCreate(filterSave)).subscribe({
        next: (res) => {
          this.projetoList = res;
          this.projetoPesquisa = this.projetoList;
          EventSharedService.get('atualizaProjetos').emit(res);
          this.loaded();
        },
      })
    );
  }

  pesquisaRapida() {
    this.projetoPesquisa = this.projetoList.filter(item =>
      item['title'].toLowerCase().includes(this.filter_pesquisa.toLowerCase())
    );
  }

  viewResonsavel(projeto: ProjetoList) {
    this.loading();

    this.addSub(
      this.pesquisaGeralService.responsavelAdjProjeto(projeto?.id).subscribe({
        next: (res) => {
          this.modalResonsavel.openModal([projeto, ...res]);
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }


  imprimirProjetos() {
    this.loading();
    // INCREMENTAR VARIAVEIS DO FILTRO NO FORM
    this.form.value['report_2_param_1'] = this.report_2_param_1?.length ? this.report_2_param_1 : [1, 2];
    this.form.value['report_2_param_2'] = this.report_2_param_2
    // INCREMENTAR VARIAVEIS DO FILTRO NO FORM RELATORIO COMPLETO
    this.form.value['report_3_param_1'] = this.report_3_param_1

    let getData = this.form.value  
    let tipo = "";
    if( this.report_type == 1){
      tipo = "projetos"
    } else if(this.report_type == 2){
      tipo = "sintetico"
    } else if(this.report_type == 3){
      tipo = "completo"      
      this.form.value['report_2_param_1'] = null;
      this.form.value['report_2_param_2'] = null;
    } else if(this.report_type == 4){
      tipo = "pontos-criticos"
    }

    let filtro = "";

    for (var key in getData) {
      if (getData.hasOwnProperty(key)) {
        // CASO SEJA UM OBJETO && VERIFICA SE É ARRAY
        if (typeof getData[key] === 'object' && Array.isArray(getData[key])) {
          if (getData[key].length > 0) {
            filtro += `&${key}=${encodeURIComponent(JSON.stringify(getData[key]))}`;
          }
        }else {
          if( getData[key] != null ) filtro+= `&${key}=${getData[key]}`;
        }
      }
    }
    const url = `${environment.serverUrl}/rest/relatorios/${tipo}?report_type=${this.report_type}${filtro}`;
    this.loaded();
    window.open(url,'_blank');
  }
  
  hasTag(projeto, id: number,key:string){
    if(projeto[key]){
      var ids = projeto[key].split(",");
      if(projeto[key + '_pg_id']){
        ids += projeto[key + '_pg_id'].split(",");
      }
      return ids.includes(id.toString());
    }
  }

  hasCreatePermission(){
    this.permissionAcl.has('ACL_PF_PROJECT_CONFIG_CREATE_GL').subscribe({
      next: (r) => {
        this.canCreate = r?.result ?? false;
      }
    });
  }

}
